import type { SubmitHandler } from 'react-hook-form';

import type { IContainerProps } from '~/components/utils/Container';
import type { IApiCreateUserBadgeResponseBody } from '~/lib/api/modules/UserBadges';
import type { IUseCreateUserBadgeMutationValues } from '~/lib/api/modules/UserBadges/hooks/useCreateUserBadgeMutation';
import type { IUserBadgeFormValues } from './UserBadgeForm';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useCreateUserBadgeMutation } from '~/lib/api/modules/UserBadges/hooks/useCreateUserBadgeMutation';
import { UserBadgeForm } from './UserBadgeForm';

export type ICreateUserBadgeFormProps = IContainerProps & {
  onSuccess?: (
    outputData: IApiCreateUserBadgeResponseBody,
    inputValues: IUseCreateUserBadgeMutationValues,
  ) => void;
  cancelUrl?: string;
  appId: string;
};

export const CreateUserBadgeForm: React.FC<ICreateUserBadgeFormProps> = (
  props,
) => {
  const { sx, onSuccess, cancelUrl, appId } = props;
  const createUserBadgeMutation = useCreateUserBadgeMutation();

  const handleSubmit: SubmitHandler<IUserBadgeFormValues> = (values) => {
    if (createUserBadgeMutation.isLoading) {
      return;
    }

    return createUserBadgeMutation.mutateAsync(
      {
        appId,
        body: {
          access: values.access!,
          color: values.color!,
          description: values.description!,
          isDefault: !!values.isDefault,
          management: values.management!,
          name: values.name!,
          privacyPolicyUrl: values.privacyPolicyUrl,
          productId: values.productId,
          subscriptionUrl: values.subscriptionUrl,
        },
      },
      { onSuccess },
    );
  };

  return (
    <ContentBlock sx={sx}>
      <UserBadgeForm
        first
        appId={appId}
        mode="creation"
        onSubmit={handleSubmit}
        cancelUrl={cancelUrl}
        defaultValues={{
          color: '#b80b61',
        }}
      />
    </ContentBlock>
  );
};
